import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { HelpService } from './../../../shared/services/help/help.service';
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Help } from 'app/shared/models/class/help/help';
import { UiService } from 'app/shared/services/ui/ui.service';

export interface DialogData {
  action: string;
  motherHelp: Help;
  help: Help;
}

type switchOptions = {
  [key: string]: any
};

const reader = new FileReader();

@Component({
  selector: 'app-open-dialog-add-edit-help',
  templateUrl: './open-dialog-add-edit-help.component.html',
  styleUrls: ['./open-dialog-add-edit-help.component.scss']
})
export class OpenDialogAddEditHelpComponent implements OnInit {

  subHelpForm: UntypedFormGroup;
  title: string;
  btnConfirm: string;
  text: string;
  help: Help;
  video: any;
  newVideo: any = null;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<OpenDialogAddEditHelpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private helpsSrv: HelpService,
    private uiService: UiService,
    private faIconSrv: FaiconService,
    private uiSrv: UiService
  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.initForm();
  }

  onSubmit(): void {


    switch (this.data.action) {
      case 'add':
        let newHelp = new Help(
          this.data.motherHelp.videoHelpKey,
          this.subHelpForm.value.title,
          this.subHelpForm.value.description
        );


        if (this.newVideo) {
          newHelp.videoName = this.newVideo.name;
        }

        this.helpsSrv.addHelp(newHelp).subscribe({
          next: () => {
            this.uiService.showSnackbar('Aide vidéo créée avec succès');
            if (this.newVideo) {
              this.saveVideoHelp(this.newVideo);
            }
            this.dialogRef.close(true)
          }
        });

        break;
      case 'edit':
        this.help = this.data.help;
        this.help.title = this.f.title.value;
        this.help.description = this.f.description.value;

        if (this.newVideo) {
          this.help.videoName = this.newVideo.name;
        }

        this.helpsSrv.updateHelp(this.help).subscribe({
          next: () => {
            this.uiService.showSnackbar('Aide vidéo modifiée avec succès');
            if (this.newVideo) {
              this.saveVideoHelp(this.newVideo);
            }
            this.dialogRef.close(true)
          }
        });


        break;

      default:
        break;
    }
  }

  private saveVideoHelp(file: any): void {
    this.helpsSrv.uploadVideo(file).subscribe({
      next: () => { }
    });
  }

  private getLabel(type: string): string {
    const label: switchOptions = {
      add: {
        title: 'Ajouter une aide vidéo',
        confirm: 'Ajouter',
        text: 'Aide vidéo ajoutée'
      },
      edit: {
        title: 'Modifier l\'aide vidéo',
        confirm: 'Mettre à jour',
        text: 'Aide vidéo mise à jour',
      },
    };
    return label[this.data.action][type];
  }

  private initComponent(): void {

    this.title = this.getLabel('title');
    this.btnConfirm = this.getLabel('confirm');
    this.text = this.getLabel('text');
  }

  get f() {
    return this.subHelpForm.controls;
  }

  private initForm(): void {
    let title = '';
    let description = '';
    if (this.data.help) {
      title = this.data.help.title;
      description = this.data.help.description;
      this.video = this.data.help.videoName;
    }
    this.subHelpForm = this.formBuilder.group({
      title: [title, Validators.required],
      description: [description, Validators.required],
      video: [null],
    });

    if (this.data.action === 'add') {
      this.subHelpForm.get('video').setValidators(Validators.required);
      this.subHelpForm.get('video').updateValueAndValidity();
    }
  }

  getFaIcon(faIcon: string): string {
    return this.faIconSrv.getFaIcon(faIcon);
  }

  uploadVideo(event?): void {
    const file = event?.target.files[0];
    this.newVideo = file;
    const type = file.type?.split('/')[1];
    (['mp4', 'vob', 'mpg', 'avi'].includes(type)) ?
      (reader.readAsDataURL(file),
        reader.onload = (res) => {
          this.subHelpForm.get('video').setValue(file);
        }) :
      this.uiService.showSnackbar('Uniquement format mp4/vob/mpg/avi');




  }

}
